import { createAction } from 'typesafe-actions';
import { ThemeVariant } from 'types/styles';
import { Config } from 'types/config';

export enum SystemAction {
  Config = 'SYSTEM_CONFIG',
  Initialized = 'SYSTEM_INITIALIZED',
  Ready = 'SYSTEM_READY',
  Theme = 'SYSTEM_THEME',
  Unauthorized = 'SYSTEM_UNAUTHORIZED',
}

export const systemConfig = createAction(SystemAction.Config)<Config>();
export const systemInitialized = createAction(SystemAction.Initialized)();
export const systemReady = createAction(SystemAction.Ready)();
export const systemTheme = createAction(SystemAction.Theme)<ThemeVariant>();
export const systemUnauthorized = createAction(SystemAction.Unauthorized)<Error>();
